import R from 'ramda'

/**
 * Update multiple folders with new copies
 * (folder items endpoint returns all changed folders
 * when an item is moved to/from folder(s))
 * @param {Object} config - The configuration object
 * @param {Array} config.changedFolders - The list of changed folders as returned from the endpoint
 * @param {Array} folders - The array of folders from the current state
 */
export default function replaceChangedFolders({ changedFolders, folders }) {
  // create a copy of the existing folders array
  let mergedFolders = folders

  const replaceFolder = changedFolder => {
    // get the index of the changedFolder in mergedFolders
    const indexFromMerged = R.findIndex(
      R.propEq('id', changedFolder.id),
      mergedFolders
    )
    if (indexFromMerged < 0)
      throw new Error(
        `replaceFolder: id ${changedFolder.id} not found in mergedFolders`
      )

    // replace the existing folder with the changedFolder
    // yes, gross object mutation, I know (;__;)
    mergedFolders = R.update(indexFromMerged, changedFolder, mergedFolders)
  }

  // Run replaceFolder for every folder in changedFolders
  changedFolders.map(replaceFolder)

  // return the gross mutated array
  return mergedFolders
}
